import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // <--- 1. Bunu ekledik

const firebaseConfig = {
  apiKey: "AIzaSyDAqhmviZxQt3wZivzL5Hxp7hM6lCuriOQ",
  authDomain: "zeytin-fabrikasi.firebaseapp.com",
  projectId: "zeytin-fabrikasi",
  storageBucket: "zeytin-fabrikasi.firebasestorage.app",
  messagingSenderId: "307583536254",
  appId: "1:307583536254:web:e95fcae4991075d0d19c2f",
  measurementId: "G-88FXJ8V333"
};

const app = initializeApp(firebaseConfig);

// Dışarıya hem veritabanını (db) hem de giriş sistemini (auth) veriyoruz
export const db = getFirestore(app);
export const auth = getAuth(app); // <--- 2. Bunu ekledik